<!--
* @Name：定价方式审批基本页面
* @Author: 王超
* @Date: 2025-09-17 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-card v-for="(item, index) in bidList" :key="item.docPk" :row-index="index + 1">
      <van-row>
        <span>标题：</span>
        <span>{{ item.title }}</span>
      </van-row>
      <van-row>
        <span>内容：</span>
        <span>{{ item.docContent }}</span>
      </van-row>
      <van-row>
        <van-button type="info" size="normal" @click="clickAttachmentList(item)">查看文件</van-button>
      </van-row>
    </hi-card>
    <attachment-info
      v-if="attachmentDialogVisible"
      :details-visible="attachmentDialogVisible"
      :attach-list="attachmentListItem"
      @close-details-dialog="attachmentDialogVisible = false"
    />
  </div>
</template>

<script>
export default {
  name: 'bidDocInfo',
  components: {
    'attachment-info': () => import('./AttachmentInfo')
  },
  data() {
    return {
      attachmentDialogVisible: false,
      attachmentListItem: []
    }
  },
  props: {
    bidList: {
      type: Array,
      required: true
    }
  },
  methods: {
    clickAttachmentList(item) {
      this.attachmentListItem = item.files
      this.attachmentDialogVisible = true
    }
  }
}
</script>
